/**
 * Format cents to a USD display string.
 *
 * The store is USD-based: stored cents are USD cents and rendered directly as
 * USD. (Any legacy `opts` second argument is accepted and ignored.)
 */
export const formatPrice = (cents) => {
  const amount = (cents || 0) / 100;
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
};

/** Format ISO date string */
export const formatDate = (iso) =>
  new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(new Date(iso));

/** Capitalize first letter */
export const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

/** Map order status to badge class */
export const statusBadge = (status) => {
  const map = {
    paid: 'badge-green', delivered: 'badge-green',
    pending: 'badge-yellow', processing: 'badge-yellow', shipped: 'badge-yellow',
    cancelled: 'badge-red', refunded: 'badge-red',
  };
  return map[status] || 'badge-gray';
};
